import PageItemControl from '../../../js/pageItem_control'
import BookItem from './bookItem';

export default class Visibility {
    target = null;
    /**
     *
     * @type {BookItem}
     * @memberof Visibility
     */
    bookItem = null;
    /**
     *
     * @type {PageItemControl}
     * @memberof Visibility
     */
    itemControl = null;

    constructor(target, bookItem, itemControl) {
        this.target = target;
        this.bookItem = bookItem;
        this.itemControl = itemControl;
    }

    setVisibleByGroup() {
        let visibility = true;
        const groupTriggers = this.itemControl.getItemsByClassName("grouptrigger", this.bookItem);
        for(let i = 0; i < groupTriggers.length; i++) {
            if(groupTriggers[i].connectNumber == this.bookItem.connectNumber) {
                visibility = false;
            }
        }

        this.target.visible = visibility;
        console.log(`set visible by group: ${this.target.visible}`);
    }
}